var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkGrayInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32294 4.323C6.35392 2.29225 9.64646 2.2924 11.6773 4.32288L12.2429 3.75742L11.6774 4.323C13.7076 6.35406 13.7078 9.64632 11.6774 11.6773L11.6774 11.6774L11.6773 11.6774C9.64631 13.7078 6.3538 13.7076 4.32304 11.6774L4.32298 11.6774L4.32291 11.6773C2.29239 9.64618 2.29228 6.35367 4.32294 4.323ZM12.243 3.75729C14.5857 6.10073 14.586 9.8996 12.243 12.243C9.8996 14.586 6.10047 14.5857 3.75729 12.243C1.41437 9.8996 1.41411 6.10047 3.75729 3.75729C6.10073 1.41411 9.89986 1.41437 12.243 3.75729ZM7.24415 5.42723C7.23476 5.82141 7.53529 6.14072 7.98608 6.14072C8.45566 6.14072 8.75593 5.82141 8.75619 5.42723C8.74654 5.01427 8.4554 4.70435 7.99522 4.70435C7.53529 4.70435 7.23476 5.014 7.24415 5.42723ZM7.99991 11.3916C8.43218 11.3916 8.78254 11.0413 8.78254 10.609V7.47849C8.78254 7.04622 8.43218 6.69587 7.99991 6.69587C7.56764 6.69587 7.21729 7.04622 7.21729 7.47849V10.609C7.21729 11.0413 7.56764 11.3916 7.99991 11.3916Z",
    fill: "#373B78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGrayInfo);
export default __webpack_public_path__ + "static/media/dark-gray-info.9bbd6489667d50d2c4a7a3deb9239596.svg";
export { ForwardRef as ReactComponent };